module.exports = __webpack_public_path__ + "images/f880ebf2e53812109e772addf590cb35.svg";